import * as Net from 'util/Net';

import {SuggestPlotsResponse} from './SuggestPlotsConstants';

export interface SuggestPlotsRequest {
  tableName: string;
  columns: Array<string>;
  rows: Array<Array<string>>;
}

export function suggestPlotsForTable(request: SuggestPlotsRequest): Promise<SuggestPlotsResponse> {
  return Net.postJSONPromise({
    url: '/1/api/notebook/ai-tools:suggest-plots',
    data: {
      tableName: request.tableName,
      columns: request.columns,
      rows: request.rows,
    },
  });
}
